import * as React from 'react'

import QspPopover from '../../../../components/school/common/QspPopover'

import { Small, spacing, Strong, WarningIcon } from 'main/ui'

import {
  Container,
  QspPopoverContainer,
  SmallStrong,
  SmallStrongLink,
  WarningIconContainer,
  WarningInfoContainer,
} from './Warning.styles'

interface IProps {
  onClickJoin: () => void
}

function Warning(props: IProps) {
  const { onClickJoin } = props

  return (
    <Container>
      <WarningIconContainer>
        <WarningIcon />
      </WarningIconContainer>

      <WarningInfoContainer>
        <div style={{ marginBottom: spacing.minorScale(1) }}>
          <Strong>This program is not part of the Wonderschool network.</Strong>

          <QspPopoverContainer>
            <QspPopover />
          </QspPopoverContainer>
        </div>

        <div>
          <SmallStrong muted>Is this your business? </SmallStrong>
          <SmallStrongLink to="#" onClick={onClickJoin}>
            Join the Wonderschool network
          </SmallStrongLink>
          &nbsp;
          <Small muted>
            for tools, support, and professional development to help your program thrive.
          </Small>
        </div>
      </WarningInfoContainer>
    </Container>
  )
}

export default React.memo(Warning)
